import { Model } from './model';

export class Bank extends Model {
  color: string | null;

  countries: string[];

  is_oauth_required: boolean;

  name: string;

  remote_id: string | null;

  remote_logo: string | null;

  routing_numbers: string[];

  website: string | null;
}
